module.exports = __webpack_public_path__ + "img/garland_1.70cc4bdf.png";